import { UserPermission } from './user.model';

export type PermissionsMap = Record<UserPermission, boolean>;

const DEFAULT_PERMISSION = false; // disabled by default

export const DEFAULT_USER_PERMISSIONS: PermissionsMap = {
  ADD_PARENT: DEFAULT_PERMISSION,
  ARCHIVE_PROJECTS: DEFAULT_PERMISSION,
  MERGE_REPORTS: DEFAULT_PERMISSION,
  VIEW_BY_FOLDERS: DEFAULT_PERMISSION,
  OPEN_REPORT: DEFAULT_PERMISSION,
  ADD_HASHTAGS_TO_PROJECTS: DEFAULT_PERMISSION,
  RENAME_REPORT: DEFAULT_PERMISSION,
  CREATE_NEW_SNAG: DEFAULT_PERMISSION,
  SYSTEM_EDIT_USER: DEFAULT_PERMISSION,
  EDIT_POINT_NAME: DEFAULT_PERMISSION,
  DOWNLOAD_FILES: DEFAULT_PERMISSION,
  MOVE_PROJECTS_TO_FOLDER: DEFAULT_PERMISSION,
  SYSTEM_ACCESS_SHARED_WITH_ME_PROJECTS: DEFAULT_PERMISSION,
  EDIT_MEMBER_ROLE_RESPONSIBILITIES: DEFAULT_PERMISSION,
  FLOOR_MANAGEMENT: DEFAULT_PERMISSION,
  SYSTEM_ADD_HASHTAGS_TO_PROJECTS: DEFAULT_PERMISSION,
  SYSTEM_PROJECT_ADD_MEMBER: DEFAULT_PERMISSION,
  SYSTEM_ARCHIVE_PROJECTS: DEFAULT_PERMISSION,
  SYSTEM_MOVE_PROJECTS_TO_FOLDER: DEFAULT_PERMISSION,
  VIEW_FOLDER: DEFAULT_PERMISSION,
  SYSTEM_TRASH_RESTORE: DEFAULT_PERMISSION,
  CREATE_REPORTS: DEFAULT_PERMISSION,
  SYSTEM_RESTORE_REPORT: DEFAULT_PERMISSION,
  SYSTEM_CREATE_PROJECTS: DEFAULT_PERMISSION,
  SYSTEM_RESTORE_FLOOR: DEFAULT_PERMISSION,
  SYSTEM_RESTORE_FILES: DEFAULT_PERMISSION,
  VIEW_PUBLIC_SNAGS: DEFAULT_PERMISSION,
  SHOW_HIDE_POINT_LIST: DEFAULT_PERMISSION,
  DOWNLOAD_360_VIDEO: DEFAULT_PERMISSION,
  OPEN_TIME_SLIDER: DEFAULT_PERMISSION,
  DELETE_FLOOR: DEFAULT_PERMISSION,
  REPLACE_PROJECT_MANAGER: DEFAULT_PERMISSION,
  RELOCATE_FLOOR_POINT: DEFAULT_PERMISSION,
  OPEN_SNAGS: DEFAULT_PERMISSION,
  SHOW_HIDE_REPORT_LIST: DEFAULT_PERMISSION,
  OBSERVATION_MANAGEMENT: DEFAULT_PERMISSION,
  OPEN_KPI: DEFAULT_PERMISSION,
  SYSTEM_ACCESS_TOOLS: DEFAULT_PERMISSION,
  EDIT_FLOOR_NAME: DEFAULT_PERMISSION,
  VIEW_FILES: DEFAULT_PERMISSION,
  VIEW_BY_REPORTS: DEFAULT_PERMISSION,
  ADD_MEMBER: DEFAULT_PERMISSION,
  UPLOAD_FILES: DEFAULT_PERMISSION,
  SYSTEM_ACCESS_MY_PROJECTS: DEFAULT_PERMISSION,
  SYSTEM_UPDATE_PROJECTS: DEFAULT_PERMISSION,
  DELETE_PROJECT: DEFAULT_PERMISSION,
  ADD_SUB_FOLDER: DEFAULT_PERMISSION,
  PROJECT_PLANNING: DEFAULT_PERMISSION,
  DELETE_POINTS: DEFAULT_PERMISSION,
  FILES_MANAGEMENT: DEFAULT_PERMISSION,
  CLOSE_PHASE: DEFAULT_PERMISSION,
  EDIT_PHASE: DEFAULT_PERMISSION,
  VIEWER_360: DEFAULT_PERMISSION,
  BACK_TO_DASHBOARD: DEFAULT_PERMISSION,
  PROJECT_PANEL_DASHBOARD_BUTTON: DEFAULT_PERMISSION,
  EDIT_PROJECT: DEFAULT_PERMISSION,
  REPORT_MANAGEMENT: DEFAULT_PERMISSION,
  SYSTEM_VIEW_PROJECT_REPORT: DEFAULT_PERMISSION,
  ADD_PHASE: DEFAULT_PERMISSION,
  EDIT_REPORT_NAME: DEFAULT_PERMISSION,
  SYSTEM_DOWNLOADS_SNAPSHOTS: DEFAULT_PERMISSION,
  SPLIT_SCREEN: DEFAULT_PERMISSION,
  SHOW_HIDE_POINT: DEFAULT_PERMISSION,
  SYSTEM_EXPORT_TO_PDF: DEFAULT_PERMISSION,
  RENAME_FOLDER: DEFAULT_PERMISSION,
  OPEN_FILE_MANAGEMENT: DEFAULT_PERMISSION,
  PROJECT_INFO: DEFAULT_PERMISSION,
  PLAY_STOP_AUTOTOUR: DEFAULT_PERMISSION,
  OPEN_OBSERVATIONS: DEFAULT_PERMISSION,
  ADD_NEW_OBSERVATION: DEFAULT_PERMISSION,
  EXPORT_TO_EXCEL: DEFAULT_PERMISSION,
  DELETE_PHASE: DEFAULT_PERMISSION,
  BUILD_PDF_REPORTS: DEFAULT_PERMISSION,
  SYSTEM_RESTORE_POINT: DEFAULT_PERMISSION,
  SYSTEM_ACCESS_ADMIN_SETTINGS: DEFAULT_PERMISSION,
  DELETE_MEMBER: DEFAULT_PERMISSION,
  DASHBOARD: DEFAULT_PERMISSION,
  SHOW_HIDE_MAP: DEFAULT_PERMISSION,
  ADD_POINTS: DEFAULT_PERMISSION,
  SHOW_HIDE_OBSERVATIONS: DEFAULT_PERMISSION,
  OPEN_OBSERVATION_DETAILS: DEFAULT_PERMISSION,
  DELETE_FOLDER: DEFAULT_PERMISSION,
  PUBLISH_REPORT: DEFAULT_PERMISSION,
  SYSTEM_ACCESS_MY_TEAM_PROJECTS: DEFAULT_PERMISSION,
  SHOW_HIDE_OBSERVATIONS_ANALYTICS: DEFAULT_PERMISSION,
  FILTER_OBSERVATIONS: DEFAULT_PERMISSION,
  SYSTEM_USER_MANAGEMENT: DEFAULT_PERMISSION,
  SYSTEM_DELETE_PROJECTS: DEFAULT_PERMISSION,
  VIEW_REPORT_INFORMATION: DEFAULT_PERMISSION,
  TOGGLE_PPE_DETECTION: DEFAULT_PERMISSION,
  RUN_PPE_DETECTION: DEFAULT_PERMISSION,
  REMOVE_PPE_AI_OBSERVATIONS: DEFAULT_PERMISSION,
  SET_DEFAULT_VIEW: DEFAULT_PERMISSION,
  ADD_FLOOR: DEFAULT_PERMISSION,
  OPEN_FILES: DEFAULT_PERMISSION,
  MOVE_PROGRESS: DEFAULT_PERMISSION,
  SEARCH_BY_ID: DEFAULT_PERMISSION,
  VIEW_SNAGS: DEFAULT_PERMISSION,
  VIEW_POINTS: DEFAULT_PERMISSION,
  VIEW_PRIVATE_SNAGS: DEFAULT_PERMISSION,
  DELETE_REPORT: DEFAULT_PERMISSION,
  CREATE_FOLDER: DEFAULT_PERMISSION,
  SYSTEM_ACCESS_ANALYTICS_CHARTS: DEFAULT_PERMISSION,
  PRINTS: DEFAULT_PERMISSION,
  MEMBER_MANAGEMENT: DEFAULT_PERMISSION,
  VIEW_FILES_FOLDERS: DEFAULT_PERMISSION,
  OPEN_OBSERVATIONS_MANAGEMENT: DEFAULT_PERMISSION,
  SYSTEM_VIEW_ANALYTICS_CHARTS: DEFAULT_PERMISSION,
  VIEW_ALL_OBSERVATIONS: DEFAULT_PERMISSION,
  COMMENT_ON_SNAGS: DEFAULT_PERMISSION,
  SYSTEM_ACTIVATE_OR_DEACTIVATE_THE_USER: DEFAULT_PERMISSION,
  SYSTEM_CREATE_USER: DEFAULT_PERMISSION,
  SYSTEM_ACCESS_360_DOCUMENTER_APPLICATION: DEFAULT_PERMISSION,
  START_PHASE: DEFAULT_PERMISSION,
  EDIT_OBSERVATION_POINT: DEFAULT_PERMISSION,
  EDIT_OBSERVATION: DEFAULT_PERMISSION,
  EDIT_OBSERVATION_CODE: DEFAULT_PERMISSION,
  CHANGE_OBSERVATION_STATUS: DEFAULT_PERMISSION,
  UPLOAD_OBSERVATION_EVIDENCE: DEFAULT_PERMISSION,
  CREATE_REPLY_ON_OBSERVATION: DEFAULT_PERMISSION,
  CAN_CLOSE_OBSERVATION: DEFAULT_PERMISSION,
  EDIT_SNAG: DEFAULT_PERMISSION,
  SYSTEM_RESTORE_OBSERVATION: DEFAULT_PERMISSION,
  DELETE_OBSERVATION: DEFAULT_PERMISSION,
  CREATE_SUB_PROJECTS: DEFAULT_PERMISSION,
  SWAP_POINT_IMAGES: DEFAULT_PERMISSION,
  GENERATE_OBSERVATION_SUMMARY_REPORT: DEFAULT_PERMISSION,
  VIEW_WEEKLY_REPORTS: DEFAULT_PERMISSION,
  CREATE_WEEKLY_REPORTS: DEFAULT_PERMISSION,
  CREATE_WEEKLY_REPORTS_COMMENT: DEFAULT_PERMISSION,
  UPDATE_WEEKLY_REPORTS: DEFAULT_PERMISSION,
  CREATE_SUMMARY_WEEKLY_REPORTS: DEFAULT_PERMISSION,
  VIEW_SUMMARY_WEEKLY_REPORTS: DEFAULT_PERMISSION,
  UPDATE_SUMMARY_WEEKLY_REPORTS: DEFAULT_PERMISSION,
  DELETE_SUMMARY_WEEKLY_REPORTS: DEFAULT_PERMISSION,
  SET_IMAGE_DIRECTION: DEFAULT_PERMISSION,
  DELETE_WEEKLY_REPORTS: DEFAULT_PERMISSION,
  VIEW_DELETED_WEEKLY_REPORTS: DEFAULT_PERMISSION,
  RESTORE_DELETED_WEEKLY_REPORTS: DEFAULT_PERMISSION,
  DELETE_KPI: DEFAULT_PERMISSION,
  EDIT_KPI: DEFAULT_PERMISSION,
  PUBLISH_KPI: DEFAULT_PERMISSION,
  SAVE_KPI: DEFAULT_PERMISSION,
  LIST_KPI: DEFAULT_PERMISSION,
  SET_DEFAULT_KPI_WEIGHTS: DEFAULT_PERMISSION,
  AUDIT_REPORT: DEFAULT_PERMISSION,
  CREATE_AUDIT_REPORT: DEFAULT_PERMISSION,
  EDIT_AUDIT_REPORT: DEFAULT_PERMISSION,
  VIEW_AUDIT_REPORT: DEFAULT_PERMISSION,
  DELETE_AUDIT_REPORT: DEFAULT_PERMISSION,
  CREATE_QUESTION_LIST: DEFAULT_PERMISSION,
  SUBMIT_QUESTION_LIST: DEFAULT_PERMISSION,
  IMPORT_TO_QUESTION_LIST: DEFAULT_PERMISSION,
  UPDATE_IN_QUESTION_LIST: DEFAULT_PERMISSION,
  CONDUCT_AUDIT: DEFAULT_PERMISSION,
  CONDUCT_QUESTIONS: DEFAULT_PERMISSION,
  SCREEN_SHOT: DEFAULT_PERMISSION,
  AUTODESK_OBSERVATION: DEFAULT_PERMISSION,
  PROJECT_PROGRESS: DEFAULT_PERMISSION,
  PROJECT_COST_DATA: DEFAULT_PERMISSION,
  VIEW_KPI: DEFAULT_PERMISSION,
  PERFORMANCE_MANAGEMENT: DEFAULT_PERMISSION,
  CRUD_INDICATORS: DEFAULT_PERMISSION,
  PROJECT_REPORTS_CRUD: DEFAULT_PERMISSION,
  ACCESS_ALL_360_REPORTS: DEFAULT_PERMISSION,
  SYSTEM_OPEN_REPORT: DEFAULT_PERMISSION,
  SYSTEM_COMMENT_ON_SNAGS: DEFAULT_PERMISSION,
  SYSTEM_ACCESS_ALL_OBSERVATIONS: DEFAULT_PERMISSION,
  SYSTEM_OPEN_OBSERVATION_DETAILS: DEFAULT_PERMISSION,
  SYSTEM_AUTODESK_OBSERVATION: DEFAULT_PERMISSION,
  SYSTEM_VIEWER_360: DEFAULT_PERMISSION,
  SYSTEM_UNIFIER_PROJECT_SYNC: DEFAULT_PERMISSION,
  SYSTEM_UNIFIER_P6_SYNC: DEFAULT_PERMISSION,
  SYSTEM_UNIFIER_OBSERVATION_MANAGEMENT: DEFAULT_PERMISSION,
  ADD_PHASE_ACTIVITY: DEFAULT_PERMISSION,
  ADD_USER: DEFAULT_PERMISSION,
  CREATE_CATEGORY: DEFAULT_PERMISSION,
  CREATE_PROGRESS_REPORT: DEFAULT_PERMISSION,
  DELEGATE_PROJECT_MANAGER_ROLE: DEFAULT_PERMISSION,
  DELETE_PHASE_ACTIVITY: DEFAULT_PERMISSION,
  DELETE_PROGRESS_REPORT: DEFAULT_PERMISSION,
  EDIT_FOLDER: DEFAULT_PERMISSION,
  EDIT_MEMBERS: DEFAULT_PERMISSION,
  EDIT_USER_ROLE: DEFAULT_PERMISSION,
  LIST_PROGRESS_REPORT: DEFAULT_PERMISSION,
  MOVE_CATEGORY: DEFAULT_PERMISSION,
  MOVE_PROJECTS_TO_LABELS: DEFAULT_PERMISSION,
  REMOVE_USER: DEFAULT_PERMISSION,
  RENAME_CATEGORY: DEFAULT_PERMISSION,
  ADD_AUTODESK_ACCOUNT: DEFAULT_PERMISSION,
  CHANGE_FILE_PRIVACY: DEFAULT_PERMISSION,
  CLONE_FILE_ROOT_CATEGORIES: DEFAULT_PERMISSION,
  CREATE_DOCUMENT: DEFAULT_PERMISSION,
  DELETE_BIM_FILE: DEFAULT_PERMISSION,
  DELETE_CATEGORY: DEFAULT_PERMISSION,
  DELETE_FILE: DEFAULT_PERMISSION,
  DOWNLOAD_DOCUMENT: DEFAULT_PERMISSION,
  DOWNLOAD_VERSION: DEFAULT_PERMISSION,
  EDIT_DOCUMENT_INFO: DEFAULT_PERMISSION,
  LIST_DELETED_FILES: DEFAULT_PERMISSION,
  LIST_FILE_CATEGORIES: DEFAULT_PERMISSION,
  LIST_FILE_MANAGEMENT_HISTORY: DEFAULT_PERMISSION,
  MAKE_OLD_VERSION_BECOME_CURRENT_VERSION: DEFAULT_PERMISSION,
  MOVE_FILE: DEFAULT_PERMISSION,
  RENAME_DOCUMENT: DEFAULT_PERMISSION,
  UPDATE_AUTODESK_ACCOUNT: DEFAULT_PERMISSION,
  UPDATE_BIM_OFFSET: DEFAULT_PERMISSION,
  UPDATE_FILE_PRIVACY: DEFAULT_PERMISSION,
  UPLOAD_BIM_FILE: DEFAULT_PERMISSION,
  UPLOAD_DOCUMENT: DEFAULT_PERMISSION,
  UPLOAD_NEW_VERSION: DEFAULT_PERMISSION,
  VIEW_BIM_FILE: DEFAULT_PERMISSION,
  VIEW_CATEGORY: DEFAULT_PERMISSION,
  VIEW_DOCUMENT_INFO: DEFAULT_PERMISSION,
  VIEW_FOLDER_INFO: DEFAULT_PERMISSION,
  VIEW_PRIVATE_DOCUMENT: DEFAULT_PERMISSION,
  VIEW_PUBLIC_DOCUMENT: DEFAULT_PERMISSION,
  VIEW_VERSION: DEFAULT_PERMISSION,
  EXPORT_KPI: DEFAULT_PERMISSION,
  LIST_KPI_INDICATORS: DEFAULT_PERMISSION,
  SHOW_PROGRESS_REPORT: DEFAULT_PERMISSION,
  UPDATE_PHASE_ACTIVITY: DEFAULT_PERMISSION,
  UPDATE_PROGRESS_REPORT: DEFAULT_PERMISSION,
  VIEW_KPI_LATEST: DEFAULT_PERMISSION,
  VIEW_PHASE_ACTIVITY: DEFAULT_PERMISSION,
  VIEW_PHASES: DEFAULT_PERMISSION,
  VIEW_INCOMPLETE_AUDIT_REPORT: DEFAULT_PERMISSION,
  SYSTEM_ACCESS_ADMIN_PORTAL: DEFAULT_PERMISSION,
  SYSTEM_ACCESS_OBSERVATIONS_ANALYTICS: DEFAULT_PERMISSION,
  SYSTEM_ADD_SUB_FOLDER: DEFAULT_PERMISSION,
  SYSTEM_ADD_USER: DEFAULT_PERMISSION,
  SYSTEM_ADJUST_VIDEOS_REPORT: DEFAULT_PERMISSION,
  SYSTEM_CREATE_FOLDER: DEFAULT_PERMISSION,
  SYSTEM_CREATE_PROJECT: DEFAULT_PERMISSION,
  SYSTEM_DELETE_FOLDER: DEFAULT_PERMISSION,
  SYSTEM_DELETE_PROJECT: DEFAULT_PERMISSION,
  SYSTEM_EDIT_PROJECT: DEFAULT_PERMISSION,
  SYSTEM_EDIT_USER_ROLE: DEFAULT_PERMISSION,
  SYSTEM_MOVE_PROJECTS_TO_LABELS: DEFAULT_PERMISSION,
  SYSTEM_PUBLISH_VIDEOS_REPORT: DEFAULT_PERMISSION,
  SYSTEM_REJECT_REPORT_FLOOR_VIDEO_REPORT: DEFAULT_PERMISSION,
  SYSTEM_REMOVE_USER: DEFAULT_PERMISSION,
  SYSTEM_RENAME_FOLDER: DEFAULT_PERMISSION,
  SYSTEM_RESTORE_FOLDER: DEFAULT_PERMISSION,
  SYSTEM_USER_SEARCH: DEFAULT_PERMISSION,
  SYSTEM_VIEW_DELETED_WEEKLY_REPORTS: DEFAULT_PERMISSION,
  SYSTEM_VIEW_FILES_FOLDERS: DEFAULT_PERMISSION,
  SYSTEM_VIEW_FOLDER: DEFAULT_PERMISSION,
  SYSTEM_VIEW_KPI_ANALYTICS: DEFAULT_PERMISSION,
  SYSTEM_VIEW_PENDING_VIDEOS_REPORTS: DEFAULT_PERMISSION,
  SYSTEM_VIEW_PROJECTS: DEFAULT_PERMISSION,
  SYSTEM_VIEW_USER_PERFORMANCE: DEFAULT_PERMISSION,
  SYSTEM_VIEW_VIDEO_REPORT_DETAILS: DEFAULT_PERMISSION,
  ASSIGN_CAPTURE_REPORT: DEFAULT_PERMISSION,
  BlurHumanFaces: DEFAULT_PERMISSION,
  CAPTURE_REPORT: DEFAULT_PERMISSION,
  MEASURE: DEFAULT_PERMISSION,
  RESTORE_WEEKLY_REPORTS: DEFAULT_PERMISSION,
  SEARCH_USERS: DEFAULT_PERMISSION,
  UPDATE_PLEDGE_MESSAGE_ENABLED: DEFAULT_PERMISSION,
  UPDATE_SETTINGS: DEFAULT_PERMISSION,
  VIEW_ACTIVE_USERS: DEFAULT_PERMISSION,
  VIEW_CLIENT_DETAILS: DEFAULT_PERMISSION,
  VIEW_PENDING_VIDEO_REPORT: DEFAULT_PERMISSION,
  VIEW_PROJECT: DEFAULT_PERMISSION,
  VIEW_PROJECT_DASHBOARD: DEFAULT_PERMISSION,
  VIEW_PROJECT_MEMBERS: DEFAULT_PERMISSION,
  ORG_SUPER_ADMIN: DEFAULT_PERMISSION,
  ORG_ADMIN: DEFAULT_PERMISSION,
  ORG_MEMBER: DEFAULT_PERMISSION,
  PROJECT_ADMIN: DEFAULT_PERMISSION,
  PROJECT_EDITOR: DEFAULT_PERMISSION,
  PROJECT_MEMBER: DEFAULT_PERMISSION,
  PROJECT_VIEWER: DEFAULT_PERMISSION,
  ORG_OPERATION_ENGINEER: DEFAULT_PERMISSION,
  OPEN_FLOOR_MANAGEMENT: DEFAULT_PERMISSION,
  TOGGLE_FLOOR_OBSERVATION_CREATION: DEFAULT_PERMISSION,
  OPEN_REPORT_MANAGEMENT: DEFAULT_PERMISSION,
  OPEN_PERFORMANCE_MANAGEMENT: DEFAULT_PERMISSION,
  OPEN_MEMBER_MANAGEMENT: DEFAULT_PERMISSION,
  SEND_CLONE_REQUEST: DEFAULT_PERMISSION,
  VIEW_CLONE_REQUEST: DEFAULT_PERMISSION,
  SYSTEM_UPDATE_CLONE_REQUEST: DEFAULT_PERMISSION,
} as const;
